const categoryType = {
    CREATE_CATEGORY_ACTION: "CREATE_CATEGORY_ACTION",
    GET_LIST_CATEGORY_ALL_ACTION: "GET_LIST_CATEGORY_ALL_ACTION",
    GET_LIST_CATEGORY_ACTION: "GET_LIST_CATEGORY_ACTION",
    GET_DETAIL_CATEGORY_ACTION: "GET_DETAIL_CATEGORY_ACTION",
    UPDATE_CATEGORY_ACTION: "UPDATE_CATEGORY_ACTION",
    CREATE_CATEGORY_SUCCESS: "CREATE_CATEGORY_SUCCESS",
    GET_LIST_CATEGORY_ALL_SUCCESS: "GET_LIST_CATEGORY_ALL_SUCCESS",
    GET_LIST_CATEGORY_SUCCESS: "GET_LIST_CATEGORY_SUCCESS",
    GET_DETAIL_CATEGORY_SUCCESS: "GET_DETAIL_CATEGORY_SUCCESS",
    UPDATE_CATEGORY_SUCCESS: "UPDATE_CATEGORY_SUCCESS",
    CREATE_CATEGORY_FAILED: "CREATE_CATEGORY_FAILED",
    GET_LIST_CATEGORY_ALL_FAILED: "GET_LIST_CATEGORY_ALL_FAILED",
    GET_LIST_CATEGORY_FAILED: "GET_LIST_CATEGORY_FAILED",
    GET_DETAIL_CATEGORY_FAILED: "GET_DETAIL_CATEGORY_FAILED",
    UPDATE_CATEGORY_FAILED: "UPDATE_CATEGORY_FAILED",
    CLEAR_CATEGORY_ACTION: "CLEAR_CATEGORY_ACTION"
}

export default categoryType;